export const TIME_UNITS = { DAY: 'day', WEEK: 'week', MONTH: 'month' } as const

export const defaultTimezone = 'UTC'
export const europeWarsawTimeZone = 'Europe/Warsaw'

export type TimeUnitTypes = (typeof TIME_UNITS)[keyof typeof TIME_UNITS]
